<script>

	import Column from './Column'

	const Grid = {
		functional: true,
		props: {
			stacked: Boolean,
			alignCenter: Boolean
		},
		render (h, ctx) {
			const { $style } = ctx
			const { stacked, alignCenter } = ctx.props
			return (
				<div class={[$style.grid, { [$style.stacked]: stacked, [$style.alignCenter]: alignCenter }]} {...ctx.data}>
					{ctx.children}
				</div>
			)
		}
	}

	Grid.Column = Column

	export default Grid

</script>

<style lang="scss" module>

	.grid {
		display:flex;
		&.stacked {
			display:block;
		}
		&.alignCenter {
			align-items:center;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Grid/index.vue